import React from 'react';

const Favorites = () => {
    return null;
}

export default Favorites;
